import React from 'react';
import styled, { keyframes } from 'styled-components';

import { useTheme } from 'styled-components';

// Recebe props para alternar tema global
interface DashboardGearProps {
  themeMode: 'dark' | 'light';
  onToggleTheme: () => void;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const GearWrapper = styled.div`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

const GearSVG = styled.svg`
  width: 48px;
  height: 48px;
  display: block;
  animation: ${spin} 4.5s linear infinite;
  transition: color 0.15s ease-out, fill 0.15s ease-out, stroke 0.15s ease-out;
`;



const DashboardGear: React.FC<DashboardGearProps> = React.memo(({ themeMode, onToggleTheme }) => {
  // Vermelho (padrão) para dark, cinza para light
  const theme = useTheme();
  const gearColor = React.useMemo(() =>
    themeMode === 'light' ? '#b3b3b3' : theme.colors.error,
    [themeMode, theme.colors.error]
  );
  return (
    <GearWrapper
      title={themeMode === 'light' ? 'Tema escuro' : 'Tema claro'}
      onClick={onToggleTheme}
      style={{ cursor: 'pointer' }}
    >
      <GearSVG viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="12" style={{ transition: 'fill 0.15s ease-out', fill: gearColor, fillOpacity: 0.18 }} />
        <circle cx="24" cy="24" r="7" style={{ transition: 'fill 0.15s ease-out', fill: gearColor, fillOpacity: 0.45 }} />
        <g style={{ transition: 'stroke 0.15s ease-out', stroke: gearColor }} strokeWidth="2.2" strokeLinecap="round">
          <path d="M24 6v4.5" />
          <path d="M24 37.5V42" />
          <path d="M6 24h4.5" />
          <path d="M37.5 24H42" />
          <path d="M11.2 11.2l3.2 3.2" />
          <path d="M33.6 33.6l3.2 3.2" />
          <path d="M11.2 36.8l3.2-3.2" />
          <path d="M33.6 14.4l3.2-3.2" />
        </g>
        <circle cx="24" cy="24" r="3.5" style={{ transition: 'fill 0.15s ease-out', fill: gearColor }} />
      </GearSVG>
    </GearWrapper>
  );
});

export default DashboardGear;
